/*
Author : Raphaël Dardeau


Markup : 

<div class="js-linking">
    <img src="foo.jpg" class="js-linking-trigger" alt=" " />
    <p class="js-linking-trigger">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cumque dolores blanditiis est quis neque eos, dolor reiciendis quas ea dignissimos, cupiditate consequunturdolores blanditiis est quis neque eos, dolor reiciendis quas ea git didignissimos, cupiditate consequuntur ipsam itaque eum possimus explicabo! Non atque, suscipit.</p>
    <a href="#" class="js-linking-target">Read more</a>
</div>


Setup : 

$(function() {
    $(".js-linking").linking();
});
*/
;(function ($, window, document, undefined) {
    "use strict";

    var pluginName = "linking",
        defaults = {
            target: '.js-linking-target',
            trigger: '.js-linking-trigger'
        };

    function Plugin (element, options) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {
        init: function () {
            this.setElements();
            this.setEvents();
            this.setStyles();
        },
        setElements: function() {
            this.$element = $(this.element);
            this.$triggers = this.$element.find(this.settings.trigger);
            this.$target = this.$element.find(this.settings.target);
        },
        setEvents: function() {
            this.$triggers.on("click", $.proxy(this.clickOnTarget, this));
            this.$triggers.add(this.$target).on("mouseenter mouseleave", $.proxy(this.toggleHoverTarget, this));
        },
        clickOnTarget: function(e) {
            if (this.$target.length > 1)
                this.$target = this.$target.filter(":visible");
            this.$target[0].click();
            e.preventDefault();
        },
        toggleHoverTarget: function(e) {
            this.$element.toggleClass("hover");
        },
        setStyles: function() {
            this.$triggers.css("cursor", "pointer");
        }
    });

    $.fn[ pluginName ] = function (options) {
        this.each(function() {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
        return this;
    };

})(jQuery, window, document);